import { MutationTree } from "vuex";
import { IPagination } from "@/types";
import { StaffState, IStaff } from "@/types/staff";

const mutations: MutationTree<StaffState> = {
  pagination: (state, staff: IPagination<IStaff[]>) => {
    state.pagination = staff;
  },
  single: (state, staff: IStaff) => {
    state.staff = staff;
  },
  canDelete: (state, is_deletable: boolean) => {
    state.is_deletable = is_deletable;
  },
  clear: state => {
    state.staff = undefined;
    state.pagination = undefined;
    state.is_deletable = undefined;
  }
};

export default mutations;
